import React from "react";
import Navbar2 from "../Components/Navbar2";
import Footer from "../Components/Footer";

function CourtRentals() {
  return (
    <>
      <Navbar2 />
      <div>
        Court Rentals
      </div>
      <Footer />
    </>
);
}

export default CourtRentals;
